module.exports = __webpack_public_path__ + "img/au.857cd69f.svg";